/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Memberships {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * @description List all available membership subscription tiers.
   *
   * @tags Memberships
   * @name ListSubscriptionTiers
   * @summary List Subscription Tiers
   * @request GET:/api/memberships/tiers
   * @secure
   */
  listSubscriptionTiers = (query, params = {}) =>
    this.http.request({
      path: `/api/memberships/tiers`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Get the active membership subscription for the current organization.
   *
   * @tags Memberships
   * @name GetCurrentSubscription
   * @summary Get Current Subscription
   * @request GET:/api/memberships/subscription
   * @secure
   */
  getCurrentSubscription = (params = {}) =>
    this.http.request({
      path: `/api/memberships/subscription`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Generate Stripe Customer Billing Portal redirect session link for organization manager.
   *
   * @tags Memberships
   * @name CreatePortalSession
   * @summary Create Portal Session
   * @request POST:/api/memberships/subscription/portal
   * @secure
   */
  createPortalSession = (data, params = {}) =>
    this.http.request({
      path: `/api/memberships/subscription/portal`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Subscribe or update current organization membership tier.
   *
   * @tags Memberships
   * @name SubscribeOrganization
   * @summary Subscribe Organization
   * @request POST:/api/memberships/subscribe
   * @secure
   */
  subscribeOrganization = (data, params = {}) =>
    this.http.request({
      path: `/api/memberships/subscribe`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Validate a promotional coupon or discount voucher.
   *
   * @tags Memberships
   * @name ValidatePromoCode
   * @summary Validate Promo Code
   * @request POST:/api/memberships/promo/validate
   */
  validatePromoCode = (data, params = {}) =>
    this.http.request({
      path: `/api/memberships/promo/validate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Cancel subscription at current period end.
   *
   * @tags Memberships
   * @name CancelSubscription
   * @summary Cancel Subscription
   * @request POST:/api/memberships/cancel
   * @secure
   */
  cancelSubscription = (params = {}) =>
    this.http.request({
      path: `/api/memberships/cancel`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * @description Create Stripe Checkout Session for subscription payment.
   *
   * @tags Memberships
   * @name CreateCheckoutSession
   * @summary Create Checkout Session
   * @request POST:/api/memberships/checkout
   * @secure
   */
  createCheckoutSession = (data, params = {}) =>
    this.http.request({
      path: `/api/memberships/checkout`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * @description Receive and dispatch Stripe Webhooks to Temporal.
   *
   * @tags Memberships
   * @name StripeWebhook
   * @summary Stripe Webhook
   * @request POST:/api/memberships/webhooks/stripe
   */
  stripeWebhook = (params = {}) =>
    this.http.request({
      path: `/api/memberships/webhooks/stripe`,
      method: "POST",
      format: "json",
      ...params,
    });
}
